import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Detail from '@/views/Detail'
import Blog from '@/views/Blog'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/products/:id',
      name: 'detail',
      component: Detail
    },
    {
      path: '/thought/:id',
      name: 'media',
      component: Blog
    }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js